import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { Popover, Select, Space, Switch } from "antd";
import { MoonOutlined, SettingOutlined, SunOutlined } from "@ant-design/icons";
import { buildUrlPath } from "lib/resolveUrl";
import { useI18n } from "components/I18nProvider";
import { useAdminTheme } from "components/AdminThemeProvider";
import { Link } from "react-router-dom";
import TestingMode from "components/TestingMode";
import styles from './style.module.scss';
import HeaderLogo from "components/HeaderLogo";
const PageHeader = ({}) => {
    const { intl, changeLocale } = useI18n();
    const { colorScheme, setColorScheme } = useAdminTheme();
    const menuContent = (_jsxs(Space, { direction: "vertical", size: "middle", children: [_jsxs(Space, { children: [`${intl.formatMessage({ id: 'language' })}:`, _jsx(Select, { "test-id": "admin-header-language-select", onChange: changeLocale, value: intl.locale, size: "small", options: [
                            {
                                value: 'en',
                                label: intl.formatMessage({ id: 'en-US' })
                            },
                            {
                                value: 'cs',
                                label: intl.formatMessage({ id: 'cs-CZ' })
                            },
                        ] })] }), _jsxs(Space, { children: [colorScheme === 'dark'
                        ? _jsx(MoonOutlined, {})
                        : _jsx(SunOutlined, {}), `${intl.formatMessage({ id: 'darkMode' })}:`, _jsx(Switch, { "test-id": "admin-header-dark-mode-switch", size: "small", checked: colorScheme === 'dark', onChange: (checked) => setColorScheme(checked ? 'dark' : 'light') })] })] }));
    return (_jsx("div", { className: styles.header, children: _jsxs("div", { className: clsx('container', styles.headerContainer), children: [_jsxs("div", { className: styles.brand, children: [_jsx(HeaderLogo, {}), _jsx(Link, { to: buildUrlPath('/admin'), className: styles.appName, "test-id": "admin-header-brand-link", children: "BeeyLive" })] }), _jsx(TestingMode, {}), _jsx("div", { className: styles.toolbar, children: _jsx(Popover, { trigger: ['click'], content: menuContent, overlayClassName: styles.popover, arrow: false, placement: "bottomRight", children: _jsx(SettingOutlined, { className: styles.settings, "test-id": "admin-header-settings-trigger" }) }) })] }) }));
};
export default PageHeader;
